enum MeasureDataType {
  Actual = 'actual',
  Target = 'target',
}

type ChartDataItem = {
  date: string;
  [MeasureDataType.Actual]: number | null | undefined;
  [MeasureDataType.Target]: number[] | number | null | undefined;
};

export { MeasureDataType };
export type { ChartDataItem };
